import { useCallback, useState } from "react";
import { Alert, Box, Typography } from "@mui/material";

import RangeSelector from "./rangeSelector";

import {
  AvailableSlotsNew as Slot,
  ServiceType,
  ServiceInfoType,
} from "utils/booking";

// =======================================================

const SchedulePicker = ({
  dpc,
  onChange,
  timeZone,
  useAll,
  staff,
  info,
  state,
}: {
  dpc: ServiceType | null;
  staff: ServiceType[];
  // eslint-disable-next-line no-unused-vars
  onChange: (slot: Slot[], loading: boolean, selectedDay: string) => void;
  timeZone: string;
  useAll: boolean;
  info: ServiceInfoType;
  state?: string;
}) => {
  const [startDate, setStartDate] = useState(new Date());
  const handleRange = useCallback(
    (param: { slot: Slot[]; isLoading: boolean; selectedDay: string }) => {
      if (param.selectedDay !== "") {
        setStartDate(
          param.selectedDay !== "" ? new Date(param.selectedDay) : new Date(),
        );
      }
      onChange(param.slot, param.isLoading, param.selectedDay);
    },
    [onChange],
  );

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          my: 1,
        }}
      >
        <Typography
          variant="h5"
          color={"primary"}
          sx={{
            fontFamily: "JazminAlt",
            fontSize: "30px",
            textAlign: "center",
          }}
        >
          {info.service_name ? `${info.service_name} - ` : ""}{" "}
          {state && state !== "" ? `(${state})` : ""} Pick a day and time that
          works for you
        </Typography>
        <Alert variant="standard" color="info">
          Please allow up to 30 seconds while we search our calendars for the
          next available appointment. Thank you for your patience.
        </Alert>

        <RangeSelector
          useAll={useAll}
          staff={staff}
          onRangeChanged={handleRange}
          timeZone={timeZone}
          dpc={dpc}
          info={info}
          startDate={startDate}
          serviceId={staff[0].service_id}
        />
      </Box>
    </>
  );
};

export default SchedulePicker;
